import axios from 'axios';

export const API_URL = `${process.env.REACT_APP_API_URL}api/public/`;
export const IMG_URL = `${process.env.REACT_APP_IMG_URL}uploads/artbanne/`;
export const API_TENANT = process.env.REACT_APP_TENANT || 'artbanne';

const http = axios.create({
    baseURL: API_URL,
    headers: {
        'x-tenant': API_TENANT,
    },
});

export const Systempay = {
    createOrder: async function (orderData) {
        try {
            return await http.post('systempay/shop/createOrder', orderData);
        } catch (error) {
            console.log(error);
            throw error;
        }
    },

    createCartPayment: async function (orderData) {
        try {
            return await http.post('systempay/shop/createPayment', orderData);
        } catch (error) {
            console.log(error);
            throw error;
        }
    },
};

export default Systempay;